import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Amplify, Auth } from 'aws-amplify';
import awsConfig from '../amplify-config';
import { getLogoutLoginPath } from 'utils/loginOrigin';

const AuthContext = React.createContext({
    isLoggedIn: false,
    onLogout: () => {},
    onLogin: () => {},
    onNavClick: () => {},
    showSideBar: true,
    userData: {},
    handleUserData: () => {},
    layoutType: '80-20',
    layoutHanlder: () => {},
    pageActive: 'dashboard',
    onPageClick: () => {},
    userObject: {},
    amplifyAuth: () => {},
    isSessionReady: false,
    brokerAssociatedBuyer: {},
    handleMyProfileData: () => {},
    myProfileData: {},
});

export const AuthContextProvider = (props) => {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [showSideBar, setShowSideBar] = useState(true);
    const [userData, setUserData] = useState();
    const [layoutType, setLayoutType] = useState('80-20');
    const [pageActive, setPageActive] = useState('dashboard');
    const [userObject, setUserObject] = useState();
    const [associatedBuyer, setAssociatedBuyer] = useState();
    const [myProfileData, setMyProfileData] = useState(null);
    const [isSessionReady, setIsSessionReady] = useState(false);

    Amplify.configure(awsConfig);

    const handleNav = useCallback(() => {
        setShowSideBar((prev) => !prev);
    }, []);

    const loginHandler = useCallback(() => {
        localStorage.setItem('isLoggedIn', '1');
    }, []);

    const logoutHandler = useCallback(() => {
        const loginPath = getLogoutLoginPath();
        localStorage.clear();
        try {
            sessionStorage.removeItem('postLoginRedirect');
            sessionStorage.setItem('logoutInitiated', '1');
        } catch {
            // ignore
        }
        setIsLoggedIn(false);
        window.location.href = loginPath;
    }, []);

    const handleUserData = useCallback((nextUserData) => {
        localStorage.setItem('userData', JSON.stringify(nextUserData));
        setUserData(nextUserData);
    }, []);

    const handleUserObject = useCallback((nextUserObject) => {
        setUserObject(nextUserObject);
    }, []);

    useEffect(() => {
        const storedUserInfo = localStorage.getItem('isLoggedIn');
        const storedUserData = localStorage.getItem('userData');
        const storedPageActive = localStorage.getItem('pageActive');
        const storedAssociatedBroker = localStorage.getItem('associatedBroker');

        if (storedUserInfo === '1') {
            setIsLoggedIn(true);
            storedUserData &&
                storedUserData !== 'undefined' &&
                storedUserData !== undefined &&
                setUserData(JSON.parse(storedUserData));
            setPageActive(storedPageActive);
            setAssociatedBuyer(storedAssociatedBroker);
        }
    }, []);

    useEffect(() => {
        Auth.currentSession()
            .then(() => setIsSessionReady(true))
            .catch(() => setIsSessionReady(false));
    }, [isLoggedIn, userData]);

    const layoutHanlder = useCallback((layout) => {
        setLayoutType(layout);
    }, []);

    const pageActiveHandler = useCallback((page) => {
        localStorage.setItem('pageActive', page);
        setPageActive(page);
    }, []);

    const amplifyAuthHandler = useCallback(() => {
        return Auth;
    }, []);

    const handleBrokerAssociateBuyer = useCallback((data) => {
        setAssociatedBuyer(data);
        localStorage.setItem('associatedBroker', data);
    }, []);

    const handleMyProfileData = useCallback((profileData) => {
        setMyProfileData(profileData);
    }, []);

    const userDataMemo = useMemo(() => {
        return JSON.parse(localStorage.getItem('userData'));
    }, [isLoggedIn]);

    const contextValue = useMemo(
        () => ({
            isLoggedIn,
            onLogin: loginHandler,
            onLogout: logoutHandler,
            onNavClick: handleNav,
            showSideBar,
            userData: userData || userDataMemo,
            handleUserData,
            layoutType,
            onLayoutClick: layoutHanlder,
            pageActive,
            onPageClick: pageActiveHandler,
            userObject,
            handleUserObject,
            amplifyAuth: amplifyAuthHandler,
            isSessionReady,
            handleBrokerAssociateBuyer,
            associatedBuyer,
            handleMyProfileData,
            myProfileData,
        }),
        [
            isLoggedIn,
            loginHandler,
            logoutHandler,
            handleNav,
            showSideBar,
            userData,
            userDataMemo,
            handleUserData,
            layoutType,
            layoutHanlder,
            pageActive,
            pageActiveHandler,
            userObject,
            handleUserObject,
            amplifyAuthHandler,
            isSessionReady,
            handleBrokerAssociateBuyer,
            associatedBuyer,
            handleMyProfileData,
            myProfileData,
        ],
    );

    return (
        <>
            <AuthContext.Provider value={contextValue}>{props.children}</AuthContext.Provider>
        </>
    );
};

export default AuthContext;
